module.exports = __webpack_public_path__ + "static/media/landing-screen.8f75ec47.jpg";